import TripleColumnContainer from '../../../Layout/Containers/TripleColumnContainer';
import styles from './targetGroupCards.module.scss';
import { StrapiImageComponent } from '../../MediaComponent/MediaComponent';
import Link from 'next/link';
import React from 'react';
import LargeWidthContainer from '../../../Layout/Containers/LargeWidthContainer';
import { BlocksRenderer } from '@strapi/blocks-react-renderer';

const TargetGroupCards = ({ targetHeader, targets }: any) => {
    if (!targets) {
        return null;
    }

    return (
        <section className={styles.targetGroupsWrapper} id="target-groups">
            {targetHeader && targetHeader.paragraph && (
                <LargeWidthContainer>
                    <div className={styles.header}>
                        <BlocksRenderer content={targetHeader.paragraph}></BlocksRenderer>
                    </div>
                </LargeWidthContainer>
            )}
            <TripleColumnContainer
                extraClassNames={styles.targetGroupsContainer}
                largeContainer={true}
            >
                {targets.map((target: any) => {
                    return (
                        <div
                            className={styles.targetGroupContainer}
                            key={`insurance-target-group-${target.heading}`}
                        >
                            <StrapiImageComponent
                                className={styles.targetGroupImage}
                                maxWidth={1644}
                                maxHeight={924}
                                strapiImage={target.image}
                            >
                                <div className={styles.overlay}></div>
                            </StrapiImageComponent>
                            <div className={styles.targetGroupInformation}>
                                <h2>{target.heading}</h2>
                                <p>{target.description}</p>
                                <Link
                                    href={target.link}
                                    title={`Go to ${target.heading}} solution for more information`}
                                >
                                    <span>Read more &#10132;</span>
                                </Link>
                            </div>
                        </div>
                    );
                })}
            </TripleColumnContainer>
        </section>
    );
};

export default TargetGroupCards;
